/**
 * TODO Rename this file to PlatformGeneratedScreeningQuestions.jsx after M2 AB Test resolution
 * If we resolve to this component, replace the old one
 */

import React from 'react';
import PropTypes from 'prop-types';

import ErrorBoundary from '@zr/components/ErrorBoundary';
import LoadingAnimation from '@zr/components/LoadingAnimation';
import withErrorContainer from '@zr/components/withErrorContainer';

import CompanyName from '../../components/CompanyName';

import usePlatformGeneratedScreeningQuestions from './usePlatformGeneratedScreeningQuestions';

export function PlatformGeneratedScreeningQuestions({
  encQuizId, ipCountryCode, locationAutocompleteUrl,
  numSuggestionsComplete, onDone, onError,
  onSuggestionAnswer, onSuggestionView,
  responseId, skillLimit, suggestions, totalScreeningQuestions, setIsLoading, encResponseId,
}) {
  const {
    displayIndex,
    displayTotalScreeningQuestions,
    handleContinue,
    handleSkip,
    profile,
    Question,
    suggestion,
  } = usePlatformGeneratedScreeningQuestions({
    encQuizId,
    isInJs6650Test: true,
    numSuggestionsComplete,
    onDone,
    onError,
    onSuggestionAnswer,
    onSuggestionView,
    responseId,
    skillLimit,
    suggestions,
    totalScreeningQuestions,
    setIsLoading,
    encResponseId,
  });

  return (
    <>
      {!profile ? (
        <div className="PlatformGeneratedScreeningQuestions">
          <LoadingAnimation />
        </div>
      ) : (
        <section className="PlatformGeneratedScreeningQuestions">
          <CompanyName companyName="ZipRecruiter" />
          <ErrorBoundary onError={onError}>
            <Question
              index={displayIndex}
              isInJs6650Test
              onContinue={handleContinue}
              onError={onError}
              {...(!!suggestion.optional && { onSkip: handleSkip })}
              profile={profile}
              // last question uses 'Submit' for button text
              submitButtonText={(displayIndex === displayTotalScreeningQuestions) ? 'Submit' : 'Continue'}
              title={suggestion.title}
              totalScreeningQuestions={displayTotalScreeningQuestions}
              // these props are for Location, but doesn't hurt to add to every step
              ipCountryCode={ipCountryCode}
              locationAutocompleteUrl={locationAutocompleteUrl}
              // for skills
              skillLimit={skillLimit}
              setIsLoading={setIsLoading}
            />
          </ErrorBoundary>
        </section>
      )}
    </>
  );
}

PlatformGeneratedScreeningQuestions.propTypes = {
  encQuizId: PropTypes.string.isRequired,
  encResponseId: PropTypes.string.isRequired,
  ipCountryCode: PropTypes.string,
  locationAutocompleteUrl: PropTypes.string.isRequired,
  numSuggestionsComplete: PropTypes.number.isRequired,
  onDone: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onSuggestionAnswer: PropTypes.func,
  onSuggestionView: PropTypes.func,
  responseId: PropTypes.number.isRequired,
  setIsLoading: PropTypes.func,
  skillLimit: PropTypes.number.isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.shape({
    optional: PropTypes.number.isRequired,
    reply_params: PropTypes.arrayOf(PropTypes.shape({})),
    suggestion_key: PropTypes.string.isRequired,
    title: PropTypes.string,
  })).isRequired,
  totalScreeningQuestions: PropTypes.number.isRequired,
};

PlatformGeneratedScreeningQuestions.defaultProps = {
  ipCountryCode: null,
  onSuggestionAnswer: () => {},
  onSuggestionView: () => {},
  setIsLoading: () => {},
};

export default withErrorContainer(PlatformGeneratedScreeningQuestions);
